<template>
    <v-container grid-list-md fluid fill-height>
        <v-layout row wrap style="width: 100%;">
            <v-flex v-if="showDirectionsBlock()" style="height: calc(100% - 100px); position: fixed; width: 300px;">
                <v-card height="100%">
                    <v-btn :to="{name: 'headDepartmentRating', params: {
                        department: $route.params.department, 
                        professor: $route.params.professor}}"
                           color="primary"
                           block
                           class="px-3"
                    ><v-icon>keyboard_backspace</v-icon> Перейти до напрямків</v-btn>
                    <v-navigation-drawer :mobile-breakpoint="0" :width="300">
                        <v-list dense>
                            <v-subheader class="mt-4 grey--name name--darken-1">Напрямки рейтингування</v-subheader>
                            <navigation-list-template :items="ratingDirections"/>
                        </v-list>
                    </v-navigation-drawer>
                </v-card>
            </v-flex>

            <v-flex style="margin-left: 300px; width: calc(100% - 460px);">
                <v-card v-if="!$route.params.direction" >
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <div class="headline">
                                    <v-icon>keyboard_backspace</v-icon>
                                    Виберіть напрямок
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
                <rating-user-worktypes-index :key="$route.fullPath" 
                                             v-if="$route.params.direction"
                                             :could-edit="false"
                                             :items-api-endpoint="`ratingUser/getWorkTypesIndividualWithSumByProfessor/${$route.params.direction}/${$route.params.professor}/${$route.params.department}`"
                                             :summary-api-endpoint="`ratingUser/getDirectionIndividualSumByProfessor/${$route.params.direction}/${$route.params.professor}`"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import NavigationListTemplate from "../../../components/common/NavigationListTemplate";
    import HttpService from "../../../HttpService";
    import RatingUserWorktypesIndex from "../../../components/rating/ratingUserWorktypes/RatingUserWorktypesIndex";

    export default {
        components: {
            NavigationListTemplate,
            RatingUserWorktypesIndex
        },
        data: () => ({
            ratingDirections: [],
        }),
        mounted() {
            HttpService.getInstance()
                .get(`ratingDirections/getAll`)
                .then(resp => {
                    this.ratingDirections = resp.map(direction => {
                        direction.name = `${direction.order}. ${direction.directionName}`;
                        direction.route = {
                            name: 'headDepartmentRatingWorkTypes',
                            params: {
                                direction: direction.id,
                                department: this.$route.params.department,
                                professor: this.$route.params.professor,
                            }
                        };

                        return direction;
                    });
                });
        },
        methods: {
            showDirectionsBlock() {
                return this.$route.name === "headDepartmentRatingWorkTypes" && this.$route.params.direction;
            },

        },
    }
</script>